(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/helpers/normalize-draw-forecast.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/helpers/normalize-draw-forecast.js');
"use strict";

const _excluded = ["cancelled"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const _svs$components$sport = svs.components.sport.tipsenShared,
  outcomeToSignIndex = _svs$components$sport.outcomeToSignIndex,
  getWinDivs = _svs$components$sport.getWinDivs;
const EventTypeId = svs.components.sportinfo.common.constants.EventTypeId;
const getDefinitionByProduct = svs.components.tipsen.engine.utils.getDefinitionByProduct;

const normalizeOutcome = _ref => {
  let drawResult = _ref.drawResult,
    eventTypeId = _ref.eventTypeId;
  const outcomes = [];

  const _eventTypeId = drawResult.eventTypeId || eventTypeId;
  if (_eventTypeId === EventTypeId.RESULT) {
    const homeResult = parseInt(drawResult.home, 10);
    outcomes.push([homeResult]);
    const awayResult = parseInt(drawResult.away, 10);
    outcomes.push([awayResult]);
  } else {
    outcomes.push([parseInt(outcomeToSignIndex[_eventTypeId][drawResult.outcome], 10)]);
  }
  return outcomes;
};
const getNormalizedDrawResults = _ref2 => {
  let drawResults = _ref2.drawResults,
    eventTypeId = _ref2.eventTypeId;
  return drawResults.map(_ref3 => {
    let cancelled = _ref3.cancelled,
      drawResult = _objectWithoutProperties(_ref3, _excluded);
    return _objectSpread(_objectSpread({}, drawResult), {}, {
      cancelled: Boolean(cancelled),
      outcome: normalizeOutcome({
        drawResult,
        eventTypeId
      })
    });
  });
};
const getNormalizedMultiForecast = (multiForecast, engineDefinition) => {
  const eventTypeId = engineDefinition.outcomes.eventTypeId;
  const outcomeCount = engineDefinition.outcomes.outcomeCount;
  const normalizedMultiForecast = new Array(outcomeCount).fill(0).map(() => []);
  multiForecast.forEach(forecast => {
    const outcomeIndex = parseInt(outcomeToSignIndex[eventTypeId][forecast.outcome], 10);
    normalizedMultiForecast[outcomeIndex].push(forecast);
  });
  const sanitizedMultiForecast = normalizedMultiForecast.map(outcome => {
    if (!outcome.length) {
      return null;
    }
    return getWinDivs(outcome);
  });
  let eventNumberIndex = 0;
  for (let i = 0; i < sanitizedMultiForecast.length; i++) {
    if (sanitizedMultiForecast[i]) {
      eventNumberIndex = sanitizedMultiForecast[i][0].eventNumber - 1;
      break;
    }
  }
  return [sanitizedMultiForecast, eventNumberIndex];
};

const normalizeDrawForecast = (forecast, productId) => {
  const cancelled = forecast.cancelled,
    drawResults = forecast.drawResults,
    winresult = forecast.winresult,
    multiForecast = forecast.multiForecast;
  const engineDefinition = getDefinitionByProduct(productId);
  const _engineDefinition$out = engineDefinition.outcomes.eventTypeId,
    eventTypeId = _engineDefinition$out === void 0 ? 1 : _engineDefinition$out;
  const normalizedDrawResult = getNormalizedDrawResults({
    drawResults,
    eventTypeId
  });
  forecast.drawResults = normalizedDrawResult;
  const normalizedWinresult = cancelled ? [] : getWinDivs(winresult);
  forecast.winresult = normalizedWinresult;
  if (multiForecast) {
    const _getNormalizedMultiFo = getNormalizedMultiForecast(multiForecast, engineDefinition),
      _getNormalizedMultiFo2 = _slicedToArray(_getNormalizedMultiFo, 2),
      normalizedMultiForecast = _getNormalizedMultiFo2[0],
      multiForecastEventNumberIndex = _getNormalizedMultiFo2[1];
    forecast.multiForecast = {
      forecast: normalizedMultiForecast,
      eventNumberIndex: multiForecastEventNumberIndex
    };
  }
  return forecast;
};
setGlobal('svs.components.tipsen.store.helpers.normalizeDrawForecast', normalizeDrawForecast);

 })(window);